import React, { useState,useEffect } from 'react'
import { useSnackbar } from 'notistack';
import CircularProgress from '@mui/material/CircularProgress';
import axios from '../../api/axios';
import useAxiosPrivate from '../../Hooks/useAxiosPrivate';
import { useUser } from '../../Hooks/useUser';

const Settings = (props) => {
    const endpoint = '/api/users/alluserinfo';
    const { user: contextUser } = useUser();
      //use the prop if available otherwise use the hook
      const user = props.User ?? contextUser;
    const axiosPrivate = useAxiosPrivate();
    const [passwordConfirmed, setPasswordConfirmed] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState('');
    const [saving, setSaving] = useState(false);
    const [bomUser, setFields] = useState({
      UserID: 0,
      UserName: '',
      Email: '',
      UserPassword:'',
    });

    // Change-email flow state
    const [newEmail, setNewEmail] = useState('');
    const [confirmNewEmail, setConfirmNewEmail] = useState('');
    const [emailSaving, setEmailSaving] = useState(false);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    async function handleRequestEmailChange() {
      const next = String(newEmail || '').trim().toLowerCase();
      const confirm = String(confirmNewEmail || '').trim().toLowerCase();
      const current = String(bomUser?.Email || bomUser?.UserName || '').trim().toLowerCase();

      if (!next || !EMAIL_RE.test(next)) {
        enqueueSnackbar('Please enter a valid email address', { variant: 'error' });
        return;
      }
      if (next !== confirm) {
        enqueueSnackbar('The email addresses do not match', { variant: 'error' });
        return;
      }
      if (next === current) {
        enqueueSnackbar('That is already your current email address', { variant: 'error' });
        return;
      }

      setEmailSaving(true);
      try {
        const res = await axiosPrivate.post('/api/users/change-email/request', { newEmail: next });
        enqueueSnackbar(
          res.data?.message || `A confirmation link has been sent to ${next}.`,
          { variant: 'success', autoHideDuration: 8000 }
        );
        setNewEmail('');
        setConfirmNewEmail('');
      } catch (error) {
        enqueueSnackbar(error.response?.data?.error || 'Failed to request email change', { variant: 'error' });
      } finally {
        setEmailSaving(false);
      }
    }

    function handlePasswordConfirm(input){
        const target = input.target;
        const value = target.value;
        //set state val for confirmpassword
        setConfirmPassword(value);

        if(value === bomUser.UserPassword)
        {
          setPasswordConfirmed(true);
          //show message
        }
        else
        {
          setPasswordConfirmed(false);
          //not allow submit
        }
      }

      function handleFieldChange(input){
        const target = input.target;
        const value = target.value;
        const name = target.id;
        //console.log(name,value);
        setFields({...bomUser,
            [name]: value
        });
      }

      async function handleSubmit(event){
        event.preventDefault();
        
        if(!bomUser.UserPassword || !confirmPassword) {
          enqueueSnackbar("Please enter and confirm your new password", { variant: 'error' });
          return;
        }
        
        if(!passwordConfirmed)
        {
            enqueueSnackbar("Passwords Do Not Match!", { variant: 'error' });
          //show message saying passwords don't match
        }
        else{
            setSaving(true);
            
            try {
              // Call API to update password
              const response = await axios.put(`/api/users/${user.UserID}/password`, {
                newPassword: bomUser.UserPassword
              });
              
              if(response.data.success) {
                enqueueSnackbar("Password changed successfully!", { variant: 'success' });
                // Clear password fields
                setFields({...bomUser, UserPassword: ''});
                setConfirmPassword('');
                setPasswordConfirmed(false);
              }
            } catch (error) {
              console.error('Error changing password:', error);
              enqueueSnackbar(error.response?.data?.error || "Failed to change password", { variant: 'error' });
            } finally {
              setSaving(false);
            }
        }
    
      }

      useEffect(() => {
        const fetchData = async () => {
          try{
            const result = await axios(`${endpoint}/${user.UserID}`);
            //console.log('Response from useEffect: ', JSON.stringify(result.data));
            // Don't load the password field - keep it empty for security
            setFields({
              ...result.data.user,
              UserPassword: '' // Always start with empty password field
            });
          }
            catch(error){
            enqueueSnackbar('User fetch failed: ', error);
          }        
        };
    
       fetchData();
         
    }, []); 

      return(
        <div>
            <div className="row px-5 pt-5">
                <div className="col-md-12 mb-2">
                    <h6>Login Details</h6>
                </div>
            <div className="col-md-6">
                <div className="form-group">
                    <label className="required-caption">Username<span className="required-field">*</span></label>
                    <input type="text" name="UserName" id="UserName" value={bomUser?.UserName} maxLength="200" onChange={handleFieldChange} className="form-control" placeholder="Enter a username" disabled/>
                    <small className="form-text text-muted">Your username is your email address. To change it, use "Change Email Address" below.</small> </div>
                </div>
            <div className="col-md-6"> </div>
            <div className="col-md-6">
                <div className="form-group">
                    <label className="required-caption">Change Password<span className="required-field">*</span></label>
                    <input type="password" name="UserPassword" id="UserPassword" value={bomUser?.UserPassword} maxLength="200" onChange={handleFieldChange} className="form-control" placeholder=""/>
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <label className="required-caption">Confirm Password<span className="required-field">*</span></label>
                    <input type="password" onChange={handlePasswordConfirm} value={confirmPassword} maxLength="200" className="form-control" placeholder=""/>
                </div>
            </div>
        </div>
      <div className="row my-5">
        <div className="col-md-12 text-center">
            <a className="button-default" onClick={handleSubmit} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px', minHeight: '38px', minWidth: '120px', padding: '8px 20px', opacity: saving ? 0.7 : 1, pointerEvents: saving ? 'none' : 'auto' }}>
              {saving && <CircularProgress size={14} style={{ color: 'white' }} />}
              Save
            </a>
        </div>
      </div>

      <hr/>

      {/* Change Email Address (with confirmation to the new address) */}
      <div className="row px-5 pt-3">
        <div className="col-md-12 mb-2">
          <h6>Change Email Address</h6>
          <small className="form-text text-muted">
            Your email address is also your login. For security, we'll send a confirmation link to your new
            address, and the change only takes effect after you click it. You'll then log in with the new email.
          </small>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="required-caption">Current Email</label>
            <input type="email" value={bomUser?.Email || bomUser?.UserName || ''} className="form-control" disabled/>
          </div>
        </div>
        <div className="col-md-6"> </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="required-caption">New Email Address<span className="required-field">*</span></label>
            <input type="email" value={newEmail} maxLength="200" onChange={(e) => setNewEmail(e.target.value)} className="form-control" placeholder="Enter your new email address"/>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="required-caption">Confirm New Email Address<span className="required-field">*</span></label>
            <input type="email" value={confirmNewEmail} maxLength="200" onChange={(e) => setConfirmNewEmail(e.target.value)} className="form-control" placeholder="Re-enter your new email address"/>
          </div>
        </div>
      </div>
      <div className="row my-5">
        <div className="col-md-12 text-center">
            <a className="button-default" onClick={handleRequestEmailChange} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px', minHeight: '38px', minWidth: '180px', padding: '8px 20px', opacity: emailSaving ? 0.7 : 1, pointerEvents: emailSaving ? 'none' : 'auto' }}>
              {emailSaving && <CircularProgress size={14} style={{ color: 'white' }} />}
              Send Confirmation
            </a>
        </div>
      </div>
    </div>
      )

}

export default Settings;